import { render, staticRenderFns } from "./SlideContents.vue?vue&type=template&id=65341a0d&"
import script from "./SlideContents.vue?vue&type=script&lang=js&"
export * from "./SlideContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports